import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import axios from "axios";

// axios.defaults.baseURL = "http://localhost:3000";

axios.defaults.baseURL =
  process.env.NODE_ENV === "production"
    ? "/auth"
    : "http://localhost:3001"; // if it breaks, this is why

axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
